import { AxiosInstance } from 'axios';

import { createReducerAction } from 'shared/createReducerAction/createReducerAction';

import { SetClient } from './clientActions.types';

export const SET_CLIENT = 'client/set-client';

export const setClient = (client: AxiosInstance): SetClient => createReducerAction(SET_CLIENT, client);
